export function stringLengthLimit(max : number, min = 0) {
  return `^.{${min},${max}}$`;
}
